var _ellipse, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.33333,
    cy: 14.5832,
    rx: 5.83333,
    ry: 2.91667,
    strokeWidth: 1.2,
    strokeLinejoin: "round",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.33333,
    cy: 5.83333,
    r: 3.33333,
    strokeWidth: 1.2,
    strokeLinejoin: "round",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5208 8.56676C12.2609 8.9641 11.946 9.3222 11.5869 9.63023C11.8756 9.71906 12.1822 9.76688 12.5 9.76688C14.212 9.76688 15.6 8.37896 15.6 6.66688C15.6 5.05546 14.3705 3.73121 12.7984 3.58105C13.0089 3.99753 13.1629 4.44745 13.2502 4.92072C13.9264 5.21166 14.4 5.88397 14.4 6.66688C14.4 7.70926 13.5605 8.55558 12.5208 8.56676Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8323 14.6579C15.8196 15.1484 15.6807 15.6203 15.4346 16.0618C15.7316 15.9792 16.0101 15.8839 16.2663 15.7771C16.7621 15.5706 17.2025 15.3093 17.5281 14.9885C17.8558 14.6657 18.1 14.2468 18.1 13.7502C18.1 13.2535 17.8558 12.8347 17.5281 12.5118C17.2025 12.191 16.7621 11.9298 16.2663 11.7232C15.4303 11.3749 14.3557 11.1483 13.1787 11.085C13.974 11.4967 14.6271 12.008 15.0865 12.5873C15.3481 12.659 15.5888 12.7409 15.8047 12.8309C16.2137 13.0013 16.5056 13.189 16.686 13.3667C16.8642 13.5423 16.9 13.6715 16.9 13.7502C16.9 13.8288 16.8642 13.958 16.686 14.1337C16.5096 14.3073 16.2269 14.4905 15.8323 14.6579Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.e64ad8564de440b65296ee940fca2e03.svg";
export { ForwardRef as ReactComponent };